import axios from 'axios';

export default {
  getAll(params = {}) {
    return axios.get('/v1/stages', { params });
  },
  create(data) {
    return axios.post('/v1/stages', data);
  },
  detail(id) {
    return axios.get(`/v1/stages/${id}`);
  },
  update(id, params) {
    return axios.put(`/v1/stages/${id}`, params);
  },
  delete(id) {
    return axios.delete(`/v1/stages/${id}`);
  }
};
